{ combineReducers } = require 'redux'
{ flash } = require './flash'
toastrReducer = require('react-redux-toastr').reducer
formReducer = require('redux-form').reducer
Immutable = require('seamless-immutable')
auth = require './auth'
{ routeReducer } = require 'redux-simple-router'

classrooms = require './classrooms'
districts = require './districts'
gradeLevels = require '../../../a2i/js/reducers/gradeLevels'
schools = require './schools'
students = require './students'
users = require './users'
history = require './history'
observations = require './observations'

rootReducer = combineReducers({
	auth
	classrooms
	districts
	flash: flash
	form: formReducer
	gradeLevels
	history
	observations
	routing: routeReducer
	schools
	students
	toastr: toastrReducer
	users
})

module.exports = rootReducer




// WEBPACK FOOTER //
// ./frontend/olos/js/reducers/index.coffee